module.exports = __webpack_public_path__ + "static/media/whatsapp-white-icon.8fadfedf.svg";